'use strict';

var RomSummaryToolbarController = function RomSummaryToolbarController($scope, $rootScope, searchCriteriaConstantsService, featureToggleService) {
  $scope.initialScreen = searchCriteriaConstantsService.ROM_SUMMARY;
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.cogValue = 'romSummaryToolbar';
  $scope.cogOptionsSet = require('../config/cogOptionsSet');
  $scope.cogOptionsSet.defaults = {
    'no-submenu': {
      'no-group': featureToggleService.isEnabled('MAPPED_MODE') ? ['REGULAR'] : ['MAPPED']
    }
  };
};
RomSummaryToolbarController.$inject = ['$scope', '$rootScope', 'SearchCriteriaConstantsService', 'FeatureToggleService'];
module.exports = RomSummaryToolbarController;